import { StyleSheet } from 'aphrodite';
import * as colors from '../../../../web/styles/colors';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	container: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		paddingLeft: 16,
		paddingRight: 16,
		paddingBottom: 16,
	},
	content: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		maxWidth: '100%',
		overflow: 'auto',
		borderRadius: 6,
		backgroundColor: colors.white,
		color: THEME.colors.text.dark,
	},
	pageHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		marginBottom: '32px',
		gap: '24px',
	},
	pageTitle: {
		fontSize: '32px',
		fontWeight: 600,
		color: colors.black,
		margin: 0,
		marginBottom: '8px',
	},
	pageDescription: {
		fontSize: '16px',
		color: colors.header,
		margin: 0,
		lineHeight: '1.5',
	},
	headerActions: {
		display: 'flex',
		gap: '12px',
		flexShrink: 0,
	},
	filtersContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginBottom: '24px',
		gap: '16px',
		flexWrap: 'wrap',
	},
	filters: {
		display: 'flex',
		gap: '12px',
		flex: 1,
		minWidth: '0',
		flexWrap: 'wrap',
	},
	searchInput: {
		minWidth: '250px',
		flex: 1,
	},
	conversationTypeFilter: {
		minWidth: '200px',
	},
	statusFilter: {
		minWidth: '150px',
	},
	groupContainer: {
		marginBottom: '32px',
	},
	groupHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		marginBottom: '12px',
		paddingBottom: '8px',
		borderBottom: `1px solid ${colors.aceGray}`,
	},
	groupTitle: {
		fontSize: '18px',
		fontWeight: 600,
		color: colors.black,
		margin: 0,
	},
	groupMeta: {
		fontSize: '14px',
		color: colors.header,
	},
	templateRow: {
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.antiFlashWhite,
		},
	},
	templateName: {
		fontWeight: 600,
		color: colors.black,
		marginBottom: '4px',
	},
	templateDescription: {
		fontSize: '14px',
		color: colors.header,
	},
	attachmentCount: {
		fontSize: '14px',
		color: colors.header,
	},
	emptyState: {
		padding: '48px 24px',
		textAlign: 'center',
		color: colors.header,
		fontSize: '16px',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '48px',
	},
});
